<template>
  <div id="app">
    <HelloWorld msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import { axios } from '@/utils/index';

export default {
  name: 'app',
  components: {
    HelloWorld
  },
  mounted() {
    axios('/get');
    axios('/set', JSON.stringify({a:1,b:1,list:[{a:1}]}));
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
}
* {
  margin: 0;
  border: none;
  outline: none;
  box-sizing: border-box!important;
}
div,span {
  display: inline-block;
}
</style>
